export { default } from "./LaundryTemplate"
